import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
  MatSnackBarHorizontalPosition,
} from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NodeEditDialogComponent } from "app/components/dialog/node-edit-dialog/node-edit-dialog.component";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { EditarAspectoComponent } from "app/editar-aspecto/editar-aspecto.component";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { DialogConfirmComponent } from "../dialog/dialog-confirm/dialog-confirm.component";

@Component({
  selector: "app-edit-global-types",
  templateUrl: "./edit-global-types.component.html",
  styleUrls: ["./edit-global-types.component.scss"],
})
export class EditGlobalTypesComponent implements OnInit, AfterViewInit {
  @ViewChild("paginatorTypes") paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  authorityUser = [];
  public superUserGeneral = false;
  loading = true;

  private arrayString: string;
  userId: number;
  public tipoEditor = false;
  // public superUser = false;

  // clienteId : number;
  tiposDocumentais: any[];
  tiposDocumentaisAdd: any[];
  nameEmpresa;
  nomeArea;
  nomeAreaBoolean = false;
  nomeAreaBooleanAll = false;
  areas: any[];
  areaPesquisada;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  displayedColumns = ["tpDocumental", "name", "descricao", "aspectos", "acoes"];
  dataSource = new MatTableDataSource<any[]>([]);
  typeSelectedId: number;

  constructor(
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private clienteService: ClienteService,
    private permissoesService: PermissoesService,
    private router: Router,
    private service: ConfigurarPastaServiceService
  ) {
    this.getGlobalPermissionUser();
  }

  ngOnInit() {
    this.getAllTiposNotLinkedToClient();

    //listen node edited or created
    this.service.isChangedNode.subscribe(() => {
      this.getAllTiposNotLinkedToClient();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getGlobalPermissionUser() {
    this.permissoesService.getPermissionsInUserLogged().subscribe(
      (data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  getAllTiposNotLinkedToClient() {
    this.loading = true;
    this.service.getAllTiposNotLinkedToClient().subscribe(
      (data: any[]) => {
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },
      (err) => {
        this.openSnackBar(
          "Ocorreu um erro ao buscar os tipos documentais",
          true
        );
        console.error(err);
        this.loading = false;
      }
    );
  }

  applyFilterTypes(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("SUPER_USER")) {
      this.superUserGeneral = true;
    }
  }

  openNewNodeDialog() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(NodeEditDialogComponent, {
      data: { clientId: null, node: null },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        console.log(result);
      },
      (err) => {
        this.openSnackBar(
          "Ocorreu um erro, tente novamente em alguns instantes",
          true
        );
      }
    );
  }

  openNodeEditDialog(node) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(NodeEditDialogComponent, {
      data: { clientId: null, node },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        console.log(result);
      },
      (err) => {
        this.openSnackBar(
          "Ocorreu um erro, tente novamente em alguns instantes",
          true
        );
      }
    );
  }

  // setTypeSelected(id) {
  //   this.typeSelectedId = id;
  // }

  openDeleteNodeDialog(id: number) {
    this.typeSelectedId = id;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja realmente excluir este tipo documental?",
        from: "edit-global-types.component.ts",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.loading = true;
        this.service.deleteNode(this.typeSelectedId).subscribe(
          (data) => {
            this.loading = false;
            this.openSnackBar("Tipo Documental excluido com sucesso", false);
            this.getAllTiposNotLinkedToClient();
          },
          (err) => {
            this.loading = false;
            this.openSnackBar(
              "Não foi possível excluir o tipo documental",
              true
            );
            console.log(err);
          }
        );
      }
    });
  }

  goToEditAspects(tipoId) {
    this.router.navigate(["/edit-aspectos", tipoId]);
  }

  goToEditProperties(tipoId) {
    localStorage.setItem('ROUTER_PROP', 'global_type');
    this.router.navigate(["/edit-properties", tipoId]);
  }

  goToTemporalidade(tipoId) {
    sessionStorage.setItem('clienteId', null);
    this.router.navigate(['/temporalidade/', tipoId]);
  }

  visualizarAspectos(item) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(EditarAspectoComponent, {
      data: {
        dataDialog: item,
        clienteId: null,
        isSuperUser: this.superUserGeneral,
      },
      width: largura,
    });
  }

  // goToArquivistico(tipoId) {
  //   this.router.navigate([`dados-arquivisticos/${this.clienteId}/${tipoId}`]);
  // }

  // navigateToUsersAuth() {
  //   this.router.navigate([`/set-users-by-documental-type/${this.clienteId}`])
  // }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["info-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/edit-global-types/edit-global-types.component.ts